import { Component, ElementRef } from '@angular/core';
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import {
  DesignAttributeType,
  OptionsAttribute,
  RuleAttribute,
  PageNavigationAttribute,
  AttributeChangeEventArgsType,
  FlowNavigationAttribute,
} from 'app/private/sxfdesigner/types/designer-attribute-type';
import { NonTransactionalFlowService } from 'app/infrastructure/services/non-transactional-flow.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'sx-actionbutton-designer',
  templateUrl: './actionbuttonDesigner.component.html',
})
export class SxActionButtonComponent extends BaseDesignerComponent {
  pageList: DesignerSelectItem[] = [];
  interactionRules: DesignerSelectItem[] = [];
  flowList: any;

  constructor(container: ElementRef, private nonTransactionalSrv: NonTransactionalFlowService, private sxTranslationService: SxTranslationService) {
    super(container, 'SxActionButton');
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext.ruleValue = '';
    this.controlContext.interactionEventValue = '';
    this.controlContext.label = this.sxTranslationService.getResource('BUTTON_SOC');
    this.controlContext.style = 'btn btn-primary';
    this.controlContext.causesValidation = true;
    this.controlContext.validationGroup = '';
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();
    info['ruleValue'] = this.controlContext.ruleValue;
    info['interactionEventValue'] =this.controlContext.interactionEventValue;
    info['navigateTo'] = this.controlContext.navigateTo;
    info['actionType'] = this.controlContext.actionType;
    info['label'] = this.controlContext.label;
    info['style'] = this.controlContext.style;
    info['causesValidation'] = this.controlContext.causesValidation;
    info['validationGroup'] = this.controlContext.validationGroup;
    info['navigateToFlow'] = this.controlContext.navigateToFlow;
    info['pageId'] = this.controlContext.pageId;
    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();
    this.pageList = this.designerContext.product.pageList;
    this.flowList = this.designerContext.product.flowList;

    if (this.pageList != null) {
      this.pageList.forEach((element) => {
        element.description = element.id;
      });
    }

    this.interactionRules = this.designerContext.product.interactionRules;

    const label = new DesignAttributeType(
      this.controlContext,
      'string',
      'label',
      'LABEL'
    );
    const styles = [
      { id: 'btn btn-primary', name: 'PRIMARY' },
      { id: 'btn btn-secondary', name: 'SECONDARY' },
      { id: 'default', name: 'VALOR_DEFAULT' },
    ];

    const style = new OptionsAttribute(
      this.controlContext,
      styles,
      'style',
      'STYLE_SOC'
    );
    let actionTypes = [
      { id: 'executeRule', name: 'EXE_RULE' },
      { id: 'interactionEvent', name: 'NON_BLOCK_INTERACTION_EVENT' },
      { id: 'navigation', name: 'NAVIGATE' },
      { id: 'openModal', name: 'OPEN_MODAL' },
    ];

    if (this.designerContext.isNonTransactional) {
      actionTypes.push({ id: 'navigateToFlow', name: 'NAV_TO_FLOW' });

      const navigationNonTranAtt = new FlowNavigationAttribute(
        this.controlContext,
        this.flowList,
        'navigateToFlow',
        'NAV_TO_FLOW'
      );
      navigationNonTranAtt.hiddenConditions = [
        ['actionType', '!=', 'navigateToFlow'],
      ];
      navigationNonTranAtt.change.subscribe((args) => this.onFlowChange(args));

      const selectedFlowPageList = new PageNavigationAttribute(
        this.controlContext,
        [],
        'pageId',
        'NAV_TO'
      );
      selectedFlowPageList.hiddenConditions = [['actionType', '!=', 'navigateToFlow']];
      this.getFlowPages(this.controlContext.navigateToFlow);
      this.attributes.push(navigationNonTranAtt, selectedFlowPageList);
    }

    const actionTypesAtt = new OptionsAttribute(
      this.controlContext,
      actionTypes,
      'actionType',
      'ACTION_TYPE'
    );
    const validates = new DesignAttributeType(
      this.controlContext,
      'boolean',
      'causesValidation',
      'TRIGGER_VALIDATIORS'
    );
    const validationGroupAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'validationGroup',
      'VALIDATION_GROUP'
    );
    style.change.subscribe((v) => this.onStyleAttChange(v));

    this.attributes.push(actionTypesAtt);
    const ruleValue = new RuleAttribute(
      this.controlContext,
      this.interactionRules,
      'ruleValue',
      'RULE_VALUE'
    );
    ruleValue.hiddenConditions = [
      ['actionType', '!=', 'executeRule'],
    ];

    const interactionEventValue = new RuleAttribute(
      this.controlContext,
      this.interactionRules,
      'interactionEventValue',
      'INTERACTION_EVENT'
    );
    interactionEventValue.hiddenConditions = [
      ['actionType', '!=', 'interactionEvent'],
    ];

    const navigationAtt = new PageNavigationAttribute(
      this.controlContext,
      this.pageList,
      'navigateTo',
      'NAV_TO'
    );
    navigationAtt.hiddenConditions = [['actionType', '!=', 'navigation']];

    this.attributes.push(
      navigationAtt,
      ruleValue,
      interactionEventValue,
      label,
      style,
      validates,
      validationGroupAtt
    );
  }

  onFlowChange(args: AttributeChangeEventArgsType): void {
    if(args.oldValue !== args.newValue)
      this.getFlowPages(args.newValue)
  }

  getFlowPages(id: string): void {
    if(id){
      this.nonTransactionalSrv.getFlowPages(id).subscribe(pages => {
        const pageAtt = (this.attributes.find(att => att.name === 'pageId') as PageNavigationAttribute);
        pageAtt.options = pages.map(page => { return <DesignerSelectItem> {
          id: page.id,
          description: page.id
        }});
      });
    }
  }

  onStyleAttChange(args: AttributeChangeEventArgsType): void {
    this.controlContext.style = args.newValue;
  }

  onDemoClick() {
    return;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/actionbuttonDesigner.component.ts